const Topbar = ({ fontList, createTextBox, createQrCode, deleteItem, fontSize, fontFamily, isBold, isItalic, textColor,
                    textDecoration, setFontSize, setFontFamily, setTextBold, setTextItalic, setTextDecoration, setTextColor,
                    shiftUp, shiftDown, textAlignment, setTextAlignment
    }) => {

        const increaseFontSize = () => {
            setFontSize(fontSize + 1)
        }

        const decreaseFontSize = () => {
            setFontSize(fontSize - 1)
        }

    return ( 
        <div className="w-100 d-flex align-items-center py-2">
            <button className="btn btn-sm py-2 px-1 btn-light border border-dark ml-2" onClick={ createQrCode }><i class="bi bi-qr-code mr-1"></i> Add QR Code</button>  
            <button id="addTextBox" className="btn btn-sm py-2 px-1 btn-light border border-dark ml-2" onClick={ createTextBox }> <i class="bi bi-bounding-box mr-1"></i>  Add TextBox</button>
            <select 
            className="ml-2 custom-select bg-white text-black font-input-width" 
            aria-label="form-select-sm"
            value={fontFamily}
            style={{fontFamily: fontFamily}}
            onChange={(e) => setFontFamily(e.target.value)}>
                {
                    fontList.map(font => <option value={font} style={{fontFamily: font}}>{font}</option>)
                }
            </select>
            <div className="d-flex">
                <button className="btn btn-light text-black border p-1 rounded-0 ml-2" onClick={ decreaseFontSize }>-</button>
                <input className="form-control form-control-sm py-2 text-black number-box-width" type="number" min="7" max="72"
                    value={fontSize}
                    // onChange={(e) => setFontSize(e.target.value)}
                />
                <button className="btn btn-light text-black border p-1 rounded-0" onClick={ increaseFontSize }>+</button>
            </div>
            <button className={"btn-sm py-2 px-2 ml-2"+ ( isBold == "bold" ? " btn-secondary" : " btn-light border border-dark" )}
                    value={isBold}
                    onClick={(e) => setTextBold(isBold == "bold" ? "normal" : "bold" )}>
                <i class="bi-type-bold" style={{fontSize: "1rem"}}></i>
            </button>
            <button className={"btn-sm py-2 px-2 ml-2"+ ( isItalic == "italic" ? " btn-secondary" : " btn-light border border-dark" )}
                value={isItalic}
                onClick={(e) => setTextItalic( isItalic == "italic" ? "normal" : "italic" )}>
                <i class="bi-type-italic" style={{fontSize: "1rem"}}></i>
            </button>
            <button className={'btn-sm py-2 px-2 ml-2'+ ( textDecoration == "underline" ? " btn-secondary" : " btn-light border border-dark" ) }
                onClick={(e) => setTextDecoration(( textDecoration == "underline" ? "" : "underline" ))}>
                <i class="bi-type-underline" style={{fontSize: "1rem"}}></i>
            </button>

            <button className={'btn-sm py-2 px-2 ml-4'+ ( textAlignment == "left" ? " btn-secondary" : " btn-light border border-dark" ) }
                onClick={(e) => setTextAlignment("left")}>
                <i class="bi bi-text-left" style={{fontSize: "1rem"}}></i>
            </button>
            <button className={'btn-sm py-2 px-2 ml-2'+ ( textAlignment == "center" ? " btn-secondary" : " btn-light border border-dark" ) }
                onClick={(e) => setTextAlignment("center")}>
                <i class="bi bi-text-center" style={{fontSize: "1rem"}}></i>
            </button>
            <button className={'btn-sm py-2 px-2 ml-2 mr-2'+ ( textAlignment == "right" ? " btn-secondary" : " btn-light border border-dark" ) }
                onClick={(e) => setTextAlignment("right")}>
                <i class="bi bi-text-right" style={{fontSize: "1rem"}}></i>
            </button>

            <small className="ml-2 text-center">Text<br/>Colour: </small>
            <input type="color" className="ml-2 mr-2" value={textColor} onChange={(e) => { setTextColor(e.target.value); console.log(e.target.value) }}/>
            <button className="btn-sm py-2 px-1 btn-light border border-dark ml-2" onClick={ shiftUp }> <i class="bi bi-front mr-1"></i> Bring Forward </button>
            <button className="btn-sm py-2 px-1 btn-light border border-dark ml-2" onClick={ shiftDown }> <i class="bi bi-back mr-1"></i> Send Backward </button>

            <button className="btn-sm py-2 px-2 btn-danger m-2" onClick={deleteItem}>
                <i class="bi bi-trash"></i>
            </button>
        </div>
     );
}
 
export default Topbar;